<template>
  <b-row>
    <b-col md="2">
      <b-form-group
        label="Ticket ID"
      >
        <b-form-input
          v-model="ticketId"
          type="text"
          placeholder="Search Ticket ID"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="3"
      class="position-relative"
    >
      <div style="display: flex; position: absolute; gap: 10px; top: 0; right: 12px;">
        <b-form-checkbox
          :checked="buyerType === 'cash'"
          @change="buyerType = buyerType === 'cash' ? '' : 'cash'; filtersChangeHandler()"
        >
          Cash
        </b-form-checkbox>
        <b-form-checkbox
          :checked="buyerType === 'credit'"
          @change="buyerType = buyerType === 'credit' ? '' : 'credit'; filtersChangeHandler()"
        >
          Credit
        </b-form-checkbox>
      </div>
      <b-form-group label="Buyers">
        <custom-v-select
          v-model="selectedBuyers"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="buyersOptions"
          label="text"
          placeholder="Select Buyers"
          multiple
          :close-on-select="false"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Created on Range"
      >
        <flat-picker
          v-model="dateRange"
          :config="{ mode: 'range'}"
          placeholder="Select Date Range"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Closed On Range"
      >

        <flat-picker
          v-model="closedOnDateRange"
          :config="{ mode: 'range'}"
          placeholder="Select Date Range"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Status"
      >
        <custom-v-select
          v-model="selectedStatusOption"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="statusOptions"
          label="text"
          placeholder="Select Option"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <DiscrepancyTypeFilter
        v-model="discrepancyType"
        :options="discrepancies"
        @input="filtersChangeHandler"
      />
    </b-col>
    <b-col md="3">
      <b-form-group label="Item Name">
        <custom-v-select
          v-model="selectedProduct"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="productOptions"
          label="text"
          placeholder="Select Item Name"
          multiple
          :close-on-select="false"
          :reduce="data => data.value"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group label="Created By">
        <custom-v-select
          v-model="selectedUsers"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="usersList"
          placeholder="Select Created By"
          multiple
          :close-on-select="false"
          label="fullname"
          :reduce="(data => data.id)"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Departments"
      >
        <custom-v-select
          v-model="departments"
          multiple
          :options="displayDepartmentOptions"
          label="text"
          placeholder="Select Departments"
          :close-on-select="false"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="3"
      class="position-relative"
    >
      <div style="display: flex; position: absolute; gap: 10px; top: 0; right: 12px;">
        <b-form-checkbox
          :checked="withBasket === 'with'"
          @change="withBasket = withBasket === 'with' ? '' : 'with'; filtersChangeHandler()"
        >
          With
        </b-form-checkbox>
        <b-form-checkbox
          :checked="withBasket === 'without'"
          @change="withBasket = withBasket === 'without' ? '' : 'without'; filtersChangeHandler()"
        >
          With Out
        </b-form-checkbox>
      </div>
      <b-form-group label="Basket No">
        <b-form-input
          v-model="basketNo"
          type="text"
          placeholder="Search Basket Number"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup, BFormInput,
  BFormCheckbox,
} from 'bootstrap-vue'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import axios from 'axios'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import DiscrepancyTypeFilter from '@/components/Tickets/DiscrepancyTypeFilter.vue'
import { buyerTicketDiscrepancies } from '@/components/Tickets/TicketDiscrepancy/discrepancy-types'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    CustomVSelect,
    FlatPicker,
    DiscrepancyTypeFilter,
  },
  data() {
    return {
      ticketId: null,
      basketNo: null,
      selectedBuyers: [],
      selectedProduct: [],
      buyersOptions: [],
      usersList: [],
      selectedUsers: [],
      productOptions: [],
      dateRange: null,
      closedOnDateRange: null,
      selectedStatusOption: null,
      statusOptions: [
        { text: 'Open', value: 'Open' },
        { text: 'In Progress', value: 'In Progress' },
        { text: 'Closed', value: 'Closed' },
      ],
      discrepancyType: [],
      departments: [],
      departmentOptions: [],
      discrepancies: buyerTicketDiscrepancies,
      buyerType: '',
      withBasket: '',
    }
  },
  computed: {
    displayDepartmentOptions() {
      return this.departmentOptions.map(option => ({
        id: option,
        text: option.charAt(0).toUpperCase() + option.slice(1),
      }))
    },
  },
  watch: {
    dateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    closedOnDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.fetchOptions()
  },
  methods: {
    async fetchOptions() {
      const buyersResponse = await axios.get('/accounts/buyers_options')
      this.buyersOptions = buyersResponse.data.data

      const departmentResponse = await axios.get('/tickets/department_options')
      this.departmentOptions = departmentResponse.data.departments

      const userListResponse = await axios.get('/delivery/users_list')
      this.usersList = userListResponse.data
      const { data: products } = await axios.get('/item_options')
      const updatedProduct = products.data.map(item => {
        const cleanedText = item.text.replace(/\*\*|#/g, '')
        return { id: item.id, text: cleanedText, value: cleanedText }
      })
      this.productOptions = updatedProduct
    },
    filtersChangeHandler() {
      const filtersdata = {}
      if (this.ticketId) {
        filtersdata.ticket_id = this.ticketId
      }

      if (this.selectedBuyers.length > 0) {
        filtersdata.buyers = this.selectedBuyers.map(item => item.id)
      }
      if (this.selectedProduct.length > 0) {
        filtersdata.product_names = this.selectedProduct.map(item => item)
      }
      if (this.basketNo) {
        filtersdata.basket_no = this.basketNo
      }

      if (this.dateRange) {
        const [dateFrom, dateTo] = this.dateRange.split(' to ')
        if (dateFrom && dateTo) {
          filtersdata.created_date_from = dateFrom
          filtersdata.created_date_to = dateTo
        }
      }
      if (this.closedOnDateRange) {
        const [closedOnDateFrom, closedOnDateTo] = this.closedOnDateRange.split(' to ')
        if (closedOnDateFrom && closedOnDateTo) {
          filtersdata.closed_on_from = closedOnDateFrom
          filtersdata.closed_on_to = closedOnDateTo
        }
      }

      if (this.selectedStatusOption) {
        filtersdata.status = this.selectedStatusOption.value
      }

      if (this.discrepancyType.length > 0) {
        filtersdata.discrepancy_types = this.discrepancyType
      }

      if (this.departments.length > 0) {
        filtersdata.departments = this.departments.map(dept => dept.id)
      }
      if (this.selectedUsers) {
        filtersdata.created_by = this.selectedUsers
      }
      if (this.buyerType === 'cash') {
        filtersdata.cash_buyers = 'true'
      } else if (this.buyerType === 'credit') {
        filtersdata.cash_buyers = 'false'
      }
      if (this.withBasket === 'with') {
        filtersdata.return_without_basket = 'false'
      } else if (this.withBasket === 'without') {
        filtersdata.return_without_basket = 'true'
      }
      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
